<template>
    <div class="custom-main custom-theme">
        <a-spin :spinning="loading" :tip="loadTip">
            <a-form class="ant-advanced-search-form">
                <a-row class="searchrow width-style-auto">
                    <a-form-item label="药品类型">
                        <a-select v-model="search.type">
                            <a-select-option value="">--请选择--</a-select-option>
                            <a-select-option v-for="item in init.types" :key="item.name" :value="item.name">
                                {{item.value}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="药品归属">
                        <a-select v-model="search.hq">
                            <a-select-option value="">--请选择--</a-select-option>
                            <a-select-option value="1">总部</a-select-option>
                            <a-select-option value="0">自定义</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="业务状态">
                        <a-select v-model="search.status">
                            <a-select-option value="">--请选择--</a-select-option>
                            <a-select-option v-for="item in init.statuses" :key="item.name" :value="item.name">
                                {{item.value}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="关键字">
                      <a-input v-model="search.keyword" placeholder="请输入药品名称/首拼模糊检索">
                        <img class="search-btn" slot="addonAfter" src="../../../assets/img/search.png" @click="searchAction"/>
                      </a-input>
                    </a-form-item>
                </a-row>
                <a-row class="searchrow width-style-auto">
                  <a-button class="custom-warn-btn" size="default" icon="download" @click="downAction('1')" style="margin-left: 40px">下载入库模板</a-button>
                  <a-upload :custom-request="uploadStockInAction"
                            :showUploadList="false">
                    <a-button class="custom-primary-btn" size="default" icon="upload" style="margin-left: 10px">入库批量导入</a-button>
                  </a-upload>
                  <a-button class="custom-warn-btn" size="default" icon="download" @click="downAction('2')" style="margin-left: 40px">下载出库模板</a-button>
                  <a-upload :custom-request="uploadStockOutAction"
                            :showUploadList="false">
                    <a-button class="custom-primary-btn" size="default" icon="upload" style="margin-left: 10px">出库批量导入</a-button>
                  </a-upload>

                </a-row>
            </a-form>
            <a-row class="search"></a-row>
            <a-table size="middle" :columns="grid.columns" :loading="grid.loading"
                     :rowSelection="{fixed:true, selectedRowKeys: grid.selections, onChange: onSelectChange}"
                     rowKey="id" :dataSource="grid.data" :scroll="{ x: '100%' }" :pagination="grid.pagination" @change="gridChangeAction">
                <span slot="operate" slot-scope="text, record">
                    <a class="custom-primary-act" @click="()=>stockInAction(record)">入库</a>
                    <a-divider type="vertical" />
                    <a class="custom-primary-act" @click="()=>stockOutAction(record)">出库</a>
                    <a-divider type="vertical" />
                    <a class="custom-warn-act" @click="()=>detailAction(record.id)">出入库记录</a>
                </span>
            </a-table>
        </a-spin>
        <a-modal :title="modal.title" :visible="modal.visible" @ok="submitStockAction" @cancel="cancelStockAction" width="800px">
            <a-spin :spinning="modal.loading" tip="正在提交数据....">
                <a-form :form="modal.form" layout="horizontal">
                    <a-row>
                        <a-col span="6">
                            <a-form-item label="药品名称" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <span>{{modal.drug.name}}</span>
                            </a-form-item>
                        </a-col>
                        <a-col span="6">
                            <a-form-item label="药品类型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <span>{{modal.drug.typeName}}</span>
                            </a-form-item>
                        </a-col>
                        <a-col span="6">
                            <a-form-item label="销售单位" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <span>{{modal.drug.salesUnit}}</span>
                            </a-form-item>
                        </a-col>
                        <a-col span="6">
                            <a-form-item label="当前库存" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <span>{{modal.drug.stockQty}}</span>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row v-if="modal.type == 'IN'">
                        <a-col span="12">
                            <a-form-item label="入库类型" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 15, xl: 15, xxl: 15 }">
                                <a-select v-decorator="['type', {rules: [{ required: true, message: '出库类型必须填写!' }], initialValue: '' }]" placeholder="请选择入库类型">
                                    <a-select-option v-for="item in init.stockInTypes" :key="item.name" :value="item.name">{{item.value}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col span="12">
                            <a-form-item label="采购单位" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 15, xl: 15, xxl: 15 }">
                                <a-select ref="stockUnit" v-decorator="['unitIndex', {rules: [{ required: true, message: '采购单位必须填写!' }], initialValue: modal.drug.unitIndex||0}]" placeholder="剂量单位">
                                    <a-select-option v-for="(item,index) in modal.drug.units" :key="item.index" :value="item.index">{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row v-if="modal.type == 'IN'">
                      <a-col span="12">
                        <a-form-item label="入库数量" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 15, xl: 15, xxl: 15 }">
                          <a-input-number :min="0.01" style="width: 100%" v-decorator="['qty', {rules: [{ required: true, message: '入库数量必须填写!' }] }]" placeholder="请输入入库数量"/>
                        </a-form-item>
                      </a-col>
                      <a-col span="12">
                        <a-form-item label="采购成本价" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 15, xl: 15, xxl: 15 }">
                          <a-input-number :min="0.01" style="width: 100%" v-decorator="['price', {rules: [{ required: true, message: '采购成本价必须填写!' }] }]" placeholder="请输入采购成本价"/>
                        </a-form-item>
                      </a-col>
                    </a-row>
                    <a-row v-if="modal.type == 'OUT'">
                        <a-col span="6">
                            <a-form-item label="出库类型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <a-select v-decorator="['type', {rules: [{ required: true, message: '出库类型必须填写!' }], initialValue: '' }]" placeholder="请选择入库类型">
                                    <a-select-option v-for="item in init.stockOutTypes" :key="item.name" :value="item.name">{{item.value}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col span="6">
                            <a-form-item label="出库单位" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                <a-select ref="stockUnit" v-decorator="['unitIndex', {rules: [{ required: true, message: '出库单位必须填写!' }], initialValue: modal.drug.unitIndex||0}]" placeholder="剂量单位">
                                    <a-select-option v-for="(item,index) in modal.drug.units" :key="item.index" :value="item.index">{{item.name}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col span="12">
                            <a-form-item label="出库数量" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 15, xl: 15, xxl: 15 }">
                                <a-input-number :min="0.01" style="width: 100%" v-decorator="['qty', {rules: [{ required: true, message: '出库数量必须填写!' }] }]" placeholder="请输入出库数量"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-spin>
        </a-modal>
        <a-modal title="出入库明细" :visible="detailModal.visible" width="80%" @cancel="closeDetailModalAction" >
            <a-spin :spinning="detailModal.loading" tip="正在查询数据....">
              <a-row class="modal-search-row width-style-auto">
                <a-form-item label="出入库类型">
                  <a-select v-model="detailModal.search.type">
                    <a-select-option value="">--请选择--</a-select-option>
                    <a-select-option v-for="item in detailModal.types" :key="item.name" :value="item.name">
                      {{item.value}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="出入库来源">
                  <a-select v-model="detailModal.search.source">
                    <a-select-option value="">--请选择--</a-select-option>
                    <a-select-option value="DOC">出入库单</a-select-option>
                    <a-select-option value="OUTPATIENT">门诊发药</a-select-option>
                    <a-select-option value="ROAM">处方流转</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item>
                  <a-button icon="search" @click="searchDetailAction" style="margin-right: 4px;">检索</a-button>
                </a-form-item>
              </a-row>
                <a-row class="search"></a-row>
                <a-table size="middle" :columns="detailModal.grid.columns" :loading="detailModal.grid.loading" :rowClassName="gridRowClass"
                         rowKey="id" :dataSource="detailModal.grid.data" :scroll="{ x: '100%' }" :pagination="detailModal.grid.pagination" @change="detailGridChangeAction">

                </a-table>
            </a-spin>
        </a-modal>
        <a-modal :title="excelModal.type == '1' ? '药品入库导入' : '药品出库导入'" :maskClosable="false" :visible="excelModal.visible" width="95%" @cancel="closeExcelModal" @ok="submitExcelAction" okText="确认导入" >
          <a-spin :spinning="excelModal.loading" :tip="excelModal.loadTip">
            <a-form :form="excelModal.form" class="ant-advanced-search-form">
              <a-row class="searchrow width-style-auto">
                <a-col span="12">
                  <a-form-item v-if="excelModal.type == '1'" label="入库类型" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" :wrapper-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }">
                    <a-select v-decorator="['type', {rules: [{ required: true, message: '入库类型必须填写!' }], initialValue: '' }]" placeholder="请选择入库类型">
                      <a-select-option v-for="item in init.stockInTypes" :key="item.name" :value="item.name">{{item.value}}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item v-if="excelModal.type == '2'" label="出库类型" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" :wrapper-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }">
                    <a-select v-decorator="['type', {rules: [{ required: true, message: '出库类型必须填写!' }], initialValue: '' }]" placeholder="请选择入库类型">
                      <a-select-option v-for="item in init.stockOutTypes" :key="item.name" :value="item.name">{{item.value}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <a-table size="middle" :columns="excelModal.grid.columns" :loading="excelModal.grid.loading"
                     rowKey="id" :dataSource="excelModal.grid.data" :scroll="{ x: '100%', y: 400 }" :pagination="false" >
                    <span slot="operate" slot-scope="text, record">
                      <a class="custom-warn-act" :disabled="record.status=='CANCELED'" >删除</a>
                    </span>
            </a-table>
          </a-spin>
        </a-modal>
    </div>
</template>

<script>
  import axios from "axios";

  export default {
    name: "Simple",
    data() {
      return {
        loading: false,
        loadTip:'正在加载数据...',
        init: {
          types: [],
          organs:[],
          stockInTypes:[],
          stockOutTypes:[],
          statuses: statuses
        },
        search: {
          type : '',
          keyword: '',
          hq:'',
          status: 'ON_SALE'
        },
        grid: {
          loading: false,
          columns: columns,
          data: [],
          selections:[],
          pagination: this.$pagination
        },
        modal:{
          title:'药品入库',
          visible : false,
          loading : false,
          type : 'IN',  //IN-入库操作  OUT-出库操作
          form: this.$form.createForm(this),
          drug : {},
        },
        detailModal:{
          visible : false,
          loading : false,
          types:[],
          search:{
            drugId:'',
            type:'',
            source:'',
          },
          grid:{
            columns: detailColumns,
            data: [],
            pagination: this.$pagination
          }
        },
        excelModal:{
          visible : false,
          loading : false,
          type : '1',
          form: this.$form.createForm(this),
          grid:{
            columns: stockInColumns,
            data: []
          }
        }
      }
    },
    beforeCreate() {
      let data = [{
        text: "首页",
        path: ""
      },{
        text: "云药房",
        path: ""
      },{
        text: "简易库存",
        path: ""
      }];
      this.$store.commit('updateBreadcrumb', data);
    },
    mounted() {
      let self = this;
      this.loadDrugType();

      this.getStockInTypes(function (res) {
        self.init.stockInTypes = res||[];
      });

      this.getStockOutTypes(function (res) {
        self.init.stockOutTypes = res||[];
      });

      this.getStockTypes(function (res) {
        self.detailModal.types = res||[];
      })

      this.searchAction();
    },
    methods: {

      loadDrugType: function () {
        let self = this;
        this.$axios.get('/api/dmz/dict/drug/types', {}).then(function (res) {
          if (res.msg.flag == 0) {
            self.init.types = res.biz;
          }
        })
      },
      buildParams:function(){
        return {
          'entity.type' : this.search.type, 'entity.keyword' : this.search.keyword, 'entity.hq':('1' == this.search.hq ? true : ('0' == this.search.hq ? false : null )), 'entity.status' : this.search.status,
        };
      },
      /**
       * 搜索按钮点击动作
       */
      searchAction:function () {
        Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
        let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
        this.loadGrid(params);
      },

      /**
       * 分页条操作
       */
      gridChangeAction: function (pagination, filters, sorter) {
        Object.assign(this.grid, {pagination: pagination});
        let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
        this.loadGrid(params);
      },

      /**
       *  行选择事件
       */
      onSelectChange:function(selectedRowKeys){
        this.grid.selections = selectedRowKeys;
      },

      /**
       * 查询药品
       */
      loadGrid:function(params){
        const self = this;
        self.grid.loading = true;
        self.$axios.get('/api/clinic/drug/list', {params: params}).then(function(res){
          self.grid.loading = false;
          if(res.msg.flag == 0){
            if(null == res.biz || res.biz.empty){
              self.$message.info({content: res.msg.message, duration: 2});
              Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
            }else{
              let _data = res.biz.data;
              for(let item of _data){
                if(item.units!=null && item.units.length>0){
                  item.units.forEach(function (item, index) {
                    item.index = index;
                  })
                }
                item.unitIndex = 0;
              }
              Object.assign(self.grid, {data: _data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
            }
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(){
          self.grid.loading = false;
        });
      },

      /**
       * 入库操作
       * @param id
       */
      stockInAction:function(record){
        this.modal.drug = record;
        this.modal.type = 'IN',
        this.modal.visible = true;

      },

      /**
       * 出库操作
       * @param id
       */
      stockOutAction:function(record){
        this.modal.drug = record;
        this.modal.type = 'OUT',
        this.modal.visible = true;
      },

      /**
       * 提交出入库操作
       */
      submitStockAction:function () {
        let self = this;
        self.modal.form.validateFields((err, values)=>{
            if(!err){
              let stockUnit = {};
              if(self.modal.drug.units!=null && self.modal.drug.units.length>0){
                stockUnit = self.modal.drug.units[values.unitIndex];
              }

              let drug = {id:self.modal.drug.id||'', stockQty:values.qty, stockUnit : stockUnit};
              if(self.modal.type == 'IN'){
                drug.price = values.price;
              }

              let params = {type:values.type||'', drugs:[drug] };

              let serverUrl = '/api/clinic/simple/stockin';
              if(self.modal.type == 'OUT'){
                serverUrl = '/api/clinic/simple/stockout';
              }
              self.modal.loading = true;
              self.modal.loadTip = '正在提交...';
              self.$axios.post(serverUrl,params).then(function (res) {
                self.modal.loading = false;
                if(res.msg.flag == 0){
                  self.$message.info({content:'提交成功'});
                  self.modal.form.resetFields();
                  Object.assign(self.modal,{drug:{}, visible : false})
                  self.gridChangeAction(self.grid.pagination);
                }else{
                  self.$message.error({content:res.msg.message, duration:2})
                }
              }).catch(function (err) {
                console.info(err)
                self.modal.loading = false;
                self.$message.error({content:'提交失败，请联系管理员', duration:2})
              })
            }else{
              console.info(errs)
            }
        })
      },
      /**
       * 取消出入库操作
       */
      cancelStockAction:function () {
        this.modal.visible = false;
      },

      /**
       * 查看出入库明细
       */
      detailAction:function(drugId){
        this.detailModal.search.drugId = drugId;
        this.detailModal.visible = true;
        this.searchDetailAction();
      },

      closeDetailModalAction:function(){
        this.detailModal.search.drugId = '';
        this.detailModal.visible = false;
      },

      buildDetailParams:function(){
        return {
          'entity.type' : this.detailModal.search.type, 'entity.drugId' : this.detailModal.search.drugId, 'entity.source' : this.detailModal.search.source,
        };
      },
      /**
       * 搜索按钮点击动作
       */
      searchDetailAction:function () {
        Object.assign(this.detailModal.grid, {pagination: Object.assign(this.detailModal.grid.pagination, {current: 1})});
        let params = Object.assign(this.buildDetailParams(), {start: 0, length: this.detailModal.grid.pagination.pageSize});
        this.loadDetailGrid(params);
      },

      /**
       * 分页条操作
       */
      detailGridChangeAction: function (pagination, filters, sorter) {
        Object.assign(this.detailModal.grid, {pagination: pagination});
        let params = Object.assign(this.buildDetailParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
        this.loadDetailGrid(params);
      },

      gridRowClass:function(item,index){
        if(item.category=='IN'){
          return 'stock-in-row'
        }else{
          return 'stock-out-row'
        }
      },

      /**
       * 查询药品
       */
      loadDetailGrid:function(params){
        const self = this;
        self.detailModal.loading = true;
        self.$axios.get('/api/clinic/stock/logs', {params: params}).then(function(res){
          self.detailModal.loading = false;
          if(res.msg.flag == 0){
            if(null !=res.biz){
              Object.assign(self.detailModal.grid, {data: res.biz.data||[], pagination:Object.assign(self.detailModal.grid.pagination, {total: res.biz.count||0})});
            }else{
              Object.assign(self.detailModal.grid, {data: [], pagination:Object.assign(self.detailModal.grid.pagination, {total: 0})});
            }

          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(){
          self.detailModal.loading = false;
        });
      },

	    /**
	     * 下载excel模板
	     */
	    downAction:function(type){
		    let self = this;
		    this.loadTip = '正在下载模板...'
		    this.loading = true;
		    let token = null;
		    if (localStorage.token) {
			    token = JSON.parse(localStorage.token);
		    }
		    let url = '/api/clinic/simple/' +(type == '1' ? 'stockin' : 'stockout' )+'/export';
		    axios({
			    baseURL:self.$axios.baseURL,
			    url:url,
			    method:'POST',
			    responseType:'blob',
			    headers:{
				    'Authorization' : "Bearer " + token.access_token
			    },
			    data:{}
		    }).then(function (res) {
			    self.loading = false;
			    let content = res;
			    let blob = new Blob([content]);
			    if('download' in document.createElement('a')){
				    let link = document.createElement('a');
				    link.download = type == '1' ? '药品入库导入模板.xls' : '药品出库导入模板.xls' ;
				    link.style.display = 'none';
				    link.href = URL.createObjectURL(blob);
				    document.body.append(link);
				    link.click();
				    URL.revokeObjectURL(link.href);
				    document.body.removeChild(link);
			    }else{
				    navigator.msSaveBlob(blob);
			    }
		    }).catch(function (err) {
			    console.info(err);
			    self.loading = false;
			    self.$message.error({content:'下载模板失败'});
		    })

	    },
      /**
       * 药品入库批量导入解析
       */
      uploadStockInAction:function(src){
        this.uploadAction(src, '1')
      },
      /**
       * 药品出库批量导入解析
       */
      uploadStockOutAction:function(src){
        this.uploadAction(src, '2')
      },

      /**
       * 导入动作
       */
      uploadAction:function(src, type){
        const self = this;
        const isLt = src.file.size / 1024 / 1024 < 10;
        if(!isLt){
          self.$message.error({content: '图片文件大小少于10M.', duration: 2});
          return false;
        }
        let params = new FormData();
        params.append("file", src.file);
        this.loadTip='正在解析数据....';
        this.loading = true;
        this.$axios.post('/api/clinic/simple/' +(type == '1' ? 'stockin' : 'stockout' )+'/analysis', params, {headers: {
            'Content-Type': 'multipart/form-data'
          },timeout: 1000 * 60 * 15}).then(function(res){
          console.info(res)
          self.loading = false;
          if(res.msg.flag == 0){
            self.$message.success({content:'解析成功'});
            let drugs = [];
            let drugIndex = 0;
            let unitIndex = 0;
            for(let drug of res.biz||[]){
              unitIndex = 0;
              drug.units.forEach(function (item,index) {
                item.index = index;
                item.unit = item;
                if(drug.stockUnit == item.name){
                  unitIndex = index;
                }
              })

              drugs.push({id:new Date().getTime()+'-'+drugIndex, drugId:drug.drugId, name : drug.name, hqName:drug.hqName, drugType:drug.drugType, spec:drug.spec, form:drug.form, stockUnit:drug.stockUnit, stockQty:drug.stockQty, price : drug.price, amt : drug.amt, manufacturer:drug.manufacturer,
                units:drug.units, unitIndex : unitIndex});
              drugIndex++;
            }

            self.excelModal.type = type;

            self.excelModal.grid.columns = type == '1' ? stockInColumns : stockOutColumns;

            self.excelModal.grid.data = drugs;
            self.excelModal.visible = true;
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(){
          self.loading = false;
        });

        return false;
      },

      /**
       * 关闭导入窗口
       */
      closeExcelModal:function () {
        this.excelModal.visible = false;
      },
      /**
       * 提交导入
       */
      submitExcelAction:function () {
        let self = this;
        this.excelModal.form.validateFields((errs,values)=>{
          if(!errs){
            let type = values.type;
            let drugs = [];
            if(self.excelModal.grid.data.length>0){
              let _stockUnit = {};
              for(let item of self.excelModal.grid.data){
                _stockUnit = null;
                for(let unit of item.units){
                 if(unit.name == item.stockUnit){
                   _stockUnit = unit;
                 }
                }
                drugs.push({id: item.drugId, stockUnit : {name:_stockUnit.name, rate:_stockUnit.rate}, stockQty:item.stockQty, price:item.price||0 })
              }
            }
            let serverUrl = self.excelModal.type == '1' ? '/api/clinic/simple/stockin' : '/api/clinic/simple/stockout';
            let params = {type:type, drugs:drugs, remark:(self.excelModal.type == '1' ? '药品简易入库导入' : '药品简易出库导入') };
            self.excelModal.loading = true;
            self.excelModal.loadTip = '正在提交...';
            self.$axios.post(serverUrl,params).then(function (res) {
              self.excelModal.loading = false;
              if(res.msg.flag == 0){
                self.$message.info({content:'提交成功'});
                self.excelModal.form.resetFields();
                Object.assign(self.excelModal,{visible : false})
                self.gridChangeAction(self.grid.pagination);
              }else{
                self.$message.error({content:res.msg.message, duration:2})
              }
            }).catch(function (err) {
              console.info(err)
              self.excelModal.loading = false;
              self.$message.error({content:'提交失败，请联系管理员', duration:2})
            })

          }else{
            console.info(errs)
          }
        })
      }

    }
  }

  let statuses = [
    {name: 'ON_SALE', value: '已上架'},
    {name: 'OFF_SALE', value: '已下架'},
    {name: 'CANCELED', value: '已作废'},
  ];

  let columns = [
    {
      title: '药品名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 180
    },
    {
      title: '生产厂家',
      dataIndex: 'manufacturer',
      key: 'manufacturer',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 120
    },
    {
      title: '药品归属',
      dataIndex: 'hq',
      key: 'hq',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : (text ? '总部' : '自定义');
      },
      width: 120
    },
    {
      title: '药品类型',
      dataIndex: 'typeName',
      key: 'typeName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 100
    },
    {
      title: '别名',
      dataIndex: 'alias',
      key: 'alias',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text.join(',');
      },
      width: 120
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '剂型',
      dataIndex: 'form',
      key: 'drugForm',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '销售单位',
      dataIndex: 'salesUnit',
      key: 'salesUnit',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '当前库存',
      dataIndex: 'stockQty',
      key: 'stockQty',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '状态',
      dataIndex: 'statusName',
      key: 'statusName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    },
    {
      title: '操作',
      key: 'operate',
      align: 'center',
      fixed: 'right',
      width: 180,
      scopedSlots: { customRender: 'operate'}
    }

  ]

  let detailColumns = [
    {
      title: '药品名称',
      dataIndex: 'drugName',
      key: 'drugName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 180
    },
    {
      title: '出入库类型',
      dataIndex: 'typeName',
      key: 'typeName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 80
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 80
    },
    {
      title: '剂型',
      dataIndex: 'form',
      key: 'drugForm',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 80
    },
    {
      title: '库存单位',
      dataIndex: 'salesUnit',
      key: 'salesUnit',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 80
    },
    {
      title: '变动前库存',
      dataIndex: 'preQty',
      key: 'preQty',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '变动数量',
      dataIndex: 'qty',
      key: 'qty',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 100
    },
    {
      title: '变动日期',
      dataIndex: 'ctime',
      key: 'ctime',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text;
      },
      width: 120
    },
  ]

  let stockInColumns = [
    {
      title: '药品名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 180
    },
    {
      title: '药品来源',
      dataIndex: 'hqName',
      key: 'hqName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '药品类型',
      dataIndex: 'drugType',
      key: 'drugType',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '剂型',
      dataIndex: 'form',
      key: 'drugForm',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '生产厂家',
      dataIndex: 'manufacturer',
      key: 'manufacturer',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '采购单位',
      dataIndex: 'stockUnit',
      key: 'stockUnit',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '采购数量',
      dataIndex: 'stockQty',
      key: 'stockQty',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text.toFixed(2);
      },
      width: 100
    },
    {
      title: '采购成本价',
      dataIndex: 'price',
      key: 'price',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text.toFixed(2);
      },
      width: 100
    },
    {
      title: '采购金额',
      dataIndex: 'amt',
      key: 'amt',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text.toFixed(2);
      },
      width: 120
    },
    {
      title: '操作',
      key: 'operate',
      align: 'center',
      fixed: 'right',
      width: 180,
      scopedSlots: { customRender: 'operate'}
    }
  ]
  let stockOutColumns = [
    {
      title: '药品名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 180
    },
    {
      title: '药品来源',
      dataIndex: 'hqName',
      key: 'hqName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '药品类型',
      dataIndex: 'drugType',
      key: 'drugType',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '规格',
      dataIndex: 'spec',
      key: 'spec',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '剂型',
      dataIndex: 'form',
      key: 'drugForm',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '生产厂家',
      dataIndex: 'manufacturer',
      key: 'manufacturer',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '出库单位',
      dataIndex: 'stockUnit',
      key: 'stockUnit',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text == '' ? '-' : text;
      },
      width: 80
    },
    {
      title: '出库数量',
      dataIndex: 'stockQty',
      key: 'stockQty',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined || text.length == 0 ? '-' : text.toFixed(2);
      },
      width: 100
    },
    {
      title: '操作',
      key: 'operate',
      align: 'center',
      fixed: 'right',
      width: 180,
      scopedSlots: { customRender: 'operate'}
    }
  ]
</script>

<style >
.modal-search-row{
    display: flex;
    justify-content: flex-start;
}
.modal-search-row .ant-form-item{
    display: flex;
    padding-right: 48px;
}
.stock-in-row{
    color: #1890ff;
}
.stock-out-row{
    color: #f86f24;
}



</style>
